import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(...inputs.flat().filter(Boolean));
}

/**
 * Round to `decimals` places using half-up on the last digit (matches Math.round on scaled value).
 */
export function roundToDecimals(value, decimals = 2) {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  const f = 10 ** decimals;
  return Math.round(n * f) / f;
}

/** Rupee amounts: 2 decimal places with standard rounding. */
export function roundMoney(value) {
  return roundToDecimals(value, 2);
}

/**
 * Nearest-rupee total and the adjustment (round off) from a 2-decimal base.
 * e.g. 230867.99 → roundedTotal 230868, roundOff +0.01
 */
export function roundOffToWholeRupee(baseAmount) {
  const n = roundMoney(baseAmount);
  if (!Number.isFinite(n)) return { roundedTotal: 0, roundOff: 0 };
  const roundedTotal = Math.round(n);
  const roundOff = roundMoney(roundedTotal - n);
  return { roundedTotal, roundOff };
}

/** Display rupees with Indian grouping. */
export function formatInr(amount, { min = 2, max = 2 } = {}) {
  const v = Number(amount);
  if (!Number.isFinite(v)) return "—";
  return v.toLocaleString("en-IN", { minimumFractionDigits: min, maximumFractionDigits: max });
}

/** Signed round-off for UI, e.g. "+0.01" or "−0.25". */
export function formatRoundOffInr(adjustment) {
  const a = roundMoney(adjustment);
  if (a === 0) return "0.00";
  const abs = formatInr(Math.abs(a));
  if (a > 0) return `+${abs}`;
  return `−${abs}`;
}
